import { createFileRoute, redirect } from "@tanstack/react-router";
import { SettingsIndex } from "../../../components/settings/settings-index";
import { useLeaveSettings } from "../../../components/settings/leave-settings";
import { DesignIcon } from "../../../components/workspace/design-icon";

/** The widest a phone is: the shell's own breakpoint (`workspace.css`). */
const PHONE = "(max-width: 767px)";

/**
 * `/settings` is the index. A desktop already has it in the sidebar, so it goes straight to the
 * first page; a phone has no sidebar to hold it, so here it is a screen of its own.
 */
export const Route = createFileRoute("/_authenticated/_workspace/settings/")({
  beforeLoad: () => {
    if (!window.matchMedia(PHONE).matches)
      throw redirect({ to: "/settings/general", replace: true });
  },
  component: SettingsScreen,
});

function SettingsScreen() {
  const leave = useLeaveSettings();
  return (
    <div className="settings-page settings-screen">
      <header className="settings-header">
        <button type="button" className="settings-up" onClick={leave}>
          <DesignIcon name="arrow-right-s-line-16" size={12} />
          <span>Back</span>
        </button>
        <h1>Settings</h1>
      </header>
      <SettingsIndex />
    </div>
  );
}
